import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";
import { getSearchedBlogPosts } from "@queries/blogs.queries";
import styles from "../styles/blogSearch.module.css";
import { useRouter } from "next/router";
import { getSearchedBlogPostsByCategory } from "../queries/blogs.queries";
import { useDebouncedCallback } from "use-debounce";
import { Box, CircularProgress } from "@mui/material";
function BlogSearchBox({
  setHasMore,
  setBlogs,
  setSearch,
  search,
  blogPage,
  setBlogPage,
  type,
  categoryName,
  setShowSearch
}) {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [loading, setLoading] = useState(false);

  // Debounce callback
  const debounced = useDebouncedCallback(
  // function
  value => {
    setDebouncedSearch(value);
  },
  // delay in ms
  500);
  useEffect(() => {
    async function getBlogs() {
      const {
        data,
        err
      } = await getSearchedBlogPosts({
        page: blogPage,
        search: debouncedSearch
      });
      if (data?.length === 0) {
        setBlogPage(0);
        setHasMore(false);
        setShowSearch(false);
      } else {
        setBlogs(data?.blogsData);
        setBlogPage(cur => cur + 1);
        setHasMore(true);
        setShowSearch(true);
      }
      setLoading(false);
    }
    async function getBlogByCategory() {
      const {
        data,
        err
      } = await getSearchedBlogPostsByCategory({
        page: blogPage,
        query: debouncedSearch,
        categoryUrl: router.query.categoryUrl
      });
      if (data?.length === 0) {
        setBlogPage(0);
        setHasMore(false);
        setShowSearch(false);
      } else {
        setBlogs(data?.blogs);
        setBlogPage(cur => cur + 1);
        setHasMore(true);
        setShowSearch(true);
      }
      setLoading(false);
    }
    if (debouncedSearch.length > 0) {
      if (type === "category") {
        getBlogByCategory();
      } else {
        getBlogs();
      }
      setBlogPage(0);
    } else {
      setShowSearch(false);
      setLoading(false);
    }
  }, [debouncedSearch, setHasMore]);
  function setSearchValue(data) {
    setSearch(data);
    setBlogPage(0);
    setHasMore(true);
    setLoading(true);
  }
  return <div className={styles.searchHeaderContainer} data-sentry-component="BlogSearchBox" data-sentry-source-file="blogSearchBox.jsx">
      <div className={styles.searchHeader}>
        <div className={styles.searchInner}>
          <h1 className={styles.blogBannerHeading}>
            {categoryName ? categoryName : t("dharmik-gyan-bhandar")}
          </h1>
          <div className={styles.searchBox}>
            <span className={styles.searchIcon}>
              <SearchIcon data-sentry-element="SearchIcon" data-sentry-source-file="blogSearchBox.jsx" />
            </span>
            <input type="text" placeholder={`${t("search-for")} ${t("maha-shivratri")}`} className={styles.searchInput} value={search} onChange={e => {
            debounced(e.target.value);
            setSearchValue(e.target.value);
          }} />
            {loading && <Box sx={{
            display: "flex",
            justifyContent: "center"
            // size: 50,
          }}>
                <CircularProgress size={20} sx={{
              color: "#ff9800"
            }} />
              </Box>}
          </div>
          <div className={styles.popularSearchContainer}>
            <div className={styles.popularSearch}>{t("popular-searches")}</div>
            <div className={styles.searchSuggestion} onClick={() => {
            debounced("Phalgun Amavasya");
            setSearchValue("Phalgun Amavasya");
          }}>
              {t("phalgun-amavasya")}
            </div>
            <div className={styles.searchSuggestion} onClick={() => {
            debounced("Meena Sankranti");
            setSearchValue("Meena Sankranti");
          }}>
              {t("meena-sankranti")}
            </div>
            <div className={styles.searchSuggestion} onClick={() => {
            debounced("Janmashtami");
            setSearchValue("Janmashtami");
          }}>
              {t("janmashtami")}
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export default BlogSearchBox;